import {getDefaultCity} from "./cities";
import {isEmpty} from "../helpers/helpers";
import {array_unique} from "../helpers/arrays";

export const handleSelectionOptions = (items, type = 'cities') => {
    let options = [];
    let selected_items = [];
    const default_city = getDefaultCity();

    if (items && items.length) {
        for (let item of items) {
            options.push({value: item.id, label: item.name, type: item.type, checked: (!isEmpty(default_city) && item.id === Number(default_city))});

            if (type === 'cities' && !isEmpty(default_city) && Number(default_city) === item.id) {
                selected_items.push(item.id);
            }
        }
    }

    return {options, selected_items};
};

export function UpdateSelectionOptions(options, data, full = false) {
    const {items} = data;

    let new_options = [...options];
    let selected_items = [];

    for (let key in new_options) {
        new_options[key]['checked'] = false;

        if (typeof items !== "undefined" && items.length > 0) {
            for (let index in items) {
                const optionValue = String(new_options[key]['value']);
                const itemValue = String(items[index]);

                if (!isEmpty(optionValue) && optionValue.indexOf('.') !== -1 && itemValue.indexOf('.') === -1) {
                    const mergedValues = optionValue.split('.');

                    if (mergedValues.length) {
                        for (let value of mergedValues) {
                            if (value === itemValue) {
                                handleSelected(key);
                            }
                        }
                    }
                } else if (optionValue === itemValue) {
                    handleSelected(key);
                }
            }
        }
    }

    function handleSelected(key) {
        new_options[key]['checked'] = true;

        if (full) {
            selected_items.push(new_options[key]);
        } else if (!isEmpty(new_options[key]) && !isEmpty(new_options[key]['value'])) {
            selected_items.push(new_options[key]['value']);
        }
    }

    return {
        show: true,
        options: new_options,
        selected_items: array_unique(selected_items),
    };
}

export function UpdateRangeSelectionOptions(options, data) {
    const checkedItems = data;
    let new_selected_range = data;

    let minValue = (!isEmpty(new_selected_range.min)) ? String(new_selected_range.min) : '';
    let maxValue = (!isEmpty(new_selected_range.max)) ? String(new_selected_range.max) : '';


    if (!isEmpty(minValue)) {
        if (!isEmpty(maxValue) && maxValue > 0 && Number(maxValue.replace(/[,]*/g, '')) < Number(minValue.replace(/[,]*/g, ''))) {
            new_selected_range.max = Number(minValue.replace(/[,]*/g, ''));
            new_selected_range.min = Number(maxValue.replace(/[,]*/g, ''));
        }
    }

    return {
        show: true,
        selected_range: {
            min: (new_selected_range.min !== "") ? checkedItems.min : null,
            max: (new_selected_range.max !== "") ? checkedItems.max : null,
        }
    };
}

export function handleCheckboxOptions(options, event) {
    const {value} = event.target;
    let new_options = options;
    let new_selected = [];

    for (let key in new_options) {
        if (new_options[key]['value'] == value) {
            new_options[key]['checked'] = !new_options[key]['checked'];
        }

        if (new_options[key]['checked'] == true) {
            new_selected.push(new_options[key]['value']);
        }
    }

    return {
        show: true,
        options: new_options,
        selected_items: new_selected
    };
}


/**
 * @param array {Object}
 * @param key {string}
 *
 * @return Array
 * */
export function pluckKeyToArray(array, key) {
    let arr = [];

    if (!isEmpty(array) && array.length) {
        Object.keys(array).forEach(k => {
            const item = array[k];

            if (!isEmpty(item)) {
                arr.push(item[key]);
            }
        });
    }

    return arr;
}